import { useEffect, type Dispatch, type SetStateAction } from "react";
import type { BaseStatusMessage } from "../types";

export function useBaseStatusDismissal(
  status: BaseStatusMessage | null,
  setStatus: Dispatch<SetStateAction<BaseStatusMessage | null>>,
  busy = false,
) {
  useEffect(() => {
    if (!status || (status.type === "info" && busy)) return;
    const delay =
      status.autoDismissMs ?? (status.type === "error" ? 8000 : 5000);
    if (delay <= 0) return;
    const timer = window.setTimeout(() => {
      setStatus((current) => (current === status ? null : current));
    }, delay);
    return () => window.clearTimeout(timer);
  }, [status, setStatus, busy]);
}
